<div class="dropdown-menu shadow dropdown-menu-left animated--grow-in dropdown-list show">
  <h6 class="dropdown-header" style="background-color: #EEECE8;border: 1px solid #EEECE8;">
    Menu Principal
  </h6>

  <a class="dropdown-item" href="#" [routerLink]="'/home'" (click)="closeMenu()">
    <i class="fas fa-home fa-sm fa-fw mr-2 text-gray-400"></i>
    Accueil<br>
  </a> 

  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/Clients'">
    <i class="fas fa-file-alt fa-sm fa-fw mr-2 text-gray-400"></i>
    Gestion des clients<br>
  </a>

  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/Subscription'">
    <i class="fab fa-battle-net fa-sm fa-fw mr-2 text-gray-400"></i>
    Gestion de souscription
  </a>

  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/GestionGroupes'">
    <i class="fas fa-book fa-sm fa-fw mr-2 text-gray-400"></i>
    Gestion de documents
  </a>

  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/Configuration'">
    <i class="fas fa-cog fa-sm fa-fw mr-2 text-gray-400"></i>
    Configuration
  </a>

  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/GestionRoles'">
    <i class="fas fa-user-lock fa-sm fa-fw mr-2 text-gray-400"></i>
    Gestion de rôles
  </a>

</div>
